import { ChangeDetectionStrategy, Component, inject, signal, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { InputTextModule } from 'primeng/inputtext';
import { StackDirectives } from 'src/app/shared/directives/stack-directives';
import { AuthStoreService, ILoginSignal } from '../../services/auth-store.service';
import { TabsModule } from 'primeng/tabs';
import { InputNumberModule } from 'primeng/inputnumber';
import { AzureAuthService } from '../../services/azure-auth.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-login-main',
  imports: [StackDirectives, InputTextModule, FormsModule, TabsModule, InputNumberModule],
  templateUrl: './login-main.component.html',
  styleUrls: ['./login-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginMainComponent implements OnInit {
  authStore = inject(AuthStoreService);
  private authAzure = inject(AzureAuthService);
  private sanitizer = inject(DomSanitizer);

  modalVideo = environment.production ? true : false;
  urlVideo: SafeResourceUrl;

  activeIndex = signal<number>(0);

  constructor(
    private toastr: ToastrService,
    public router: Router,
    private cdr: ChangeDetectorRef
  ) {
    // Convertir URL de YouTube a embed y sanitizar
    const youtubeUrl = 'https://www.youtube.com/embed/9w7qFF588sg?autoplay=1&mute=1&controls=1&rel=0';
    this.urlVideo = this.sanitizer.bypassSecurityTrustResourceUrl(youtubeUrl);
  }

  ngOnInit(): void {
    localStorage.removeItem('modLog');
  }

  onTabChange(index: any) {
    this.authStore.loginData.set({} as ILoginSignal);
    this.activeIndex.set(index);
  }

  onLogin(): void {
    if (!this.authStore.loginData().usuario) {
      this.toastr.error('Por favor, ingresa tu cédula o correo electrónico.', 'Error de inicio de sesión');
      return;
    }

    const usuario = this.authStore.loginData().usuario!;

    if (this.activeIndex() === 0) {
      // Cédula tab
      const usuarioStr = String(usuario).trim();
      this.authStore.loginData.set({
        ...this.authStore.loginData(),
        usuario: usuarioStr
      });
      this.updateLoginDataAndNavigate(['/login/cedula']);
      return;
    }

    if (this.activeIndex() === 1) {
      // Email tab
      if (!this.validateEmail(usuario)) {
        this.toastr.error('Ingrese un correo electrónico válido.', 'Error de inicio de sesión');
        return;
      }
      this.updateLoginDataAndNavigate(['/login/email']);
      return;
    }
  }

  private updateLoginDataAndNavigate(route: any[]): void {
    this.authStore.loginData().usuario.toString();
    this.router.navigate(route);
  }

  private validateEmail(input: string): boolean {
    if (!/^[^@]+@[^@]+\.[^@]+$/.test(input)) {
      return false;
    }
    return true;
  }

  toLoginAzure(): void {
    this.authAzure.deleteInfo();
    this.router.navigate(['/login/azure-auth']);
  }

  closeModalVideo(): void {
    // console.log('Cerrando modal video');
    this.modalVideo = false;
  }
}
